import moment from "moment";

// Table columns for top paid people
export const topPaidColumns = [
  {
    dataField: "payee_name",
    text: "Name",
    formatter: (_, row) => (
      <div className="name-mobile-container">
        <div className="primary-text">{row.payee_name || "NA"}</div>
        <div className="secondary-text">{row.payee_mobile || "NA"}</div>
      </div>
    ),
  },
  {
    dataField: "total_amount",
    text: "Total Amount",
    formatter: (_, row) => (
      <div className="amount-container">
        ₹{parseInt(row.total_amount || 0).toLocaleString()}
      </div>
    ),
  },
  {
    dataField: "payee_status",
    text: "Status",
    formatter: (_, row) => {
      const getStatusClass = (status) => {
        switch (status) {
          case "active":
            return "active";
          case "inactive":
            return "inactive";
          case "deleted":
            return "deleted";
          default:
            return "inactive";
        }
      };

      return (
        <span className={`status-badge ${getStatusClass(row.payee_status)}`}>
          {row.payee_status || "NA"}
        </span>
      );
    },
  },
];

// Table columns for top gyms
export const topGymsColumns = [
  {
    dataField: "gym_name",
    text: "Gym Name",
    formatter: (_, row) => (
      <div className="gym-info-container">
        <div className="primary-text">{row.gym_name || "WTF Expense"}</div>
        <div className="secondary-text">
          Last Expense :{" "}
          {row.last_expense_date
            ? moment(row.last_expense_date).format("DD MMM YYYY")
            : "NA"}
        </div>
      </div>
    ),
  },
  {
    dataField: "total_spend",
    text: "Total Spend",
    formatter: (_, row) => (
      <div className="amount-container">
        ₹{parseInt(row.total_spend || 0).toLocaleString()}
      </div>
    ),
  },
  {
    dataField: "total_expenses",
    text: "Total Expenses",
    formatter: (_, row) => (
      <div className="date-container">{row.total_expenses || 0} expenses</div>
    ),
  },
];

// Table columns for pending FD vendor payments
export const pendingFdVendorColumns = [
  {
    dataField: "requester_name",
    text: "Requester",
    formatter: (_, row) => (
      <div className="name-mobile-container">
        <div className="primary-text">{row.requester_name || "NA"}</div>
        <div className="secondary-text">{row.requester_mobile || "NA"}</div>
      </div>
    ),
  },
  {
    dataField: "pending_requests_count",
    text: "Pending Requests",
    formatter: (_, row) => (
      <div className="count-container">
        <div className="count-value">{row.pending_requests_count || 0}</div>
        <div className="count-label">requests</div>
      </div>
    ),
  },
  {
    dataField: "total_pending_amount",
    text: "Pending Amount",
    formatter: (_, row) => (
      <div className="amount-container">
        ₹{parseInt(row.total_pending_amount || 0).toLocaleString()}
      </div>
    ),
  },
  {
    dataField: "requester_status",
    text: "Status",
    formatter: (_, row) => {
      const getStatusClass = (status) => {
        switch (status) {
          case "active":
            return "active";
          case "inactive":
            return "inactive";
          case "deleted":
            return "deleted";
          default:
            return "inactive";
        }
      };

      return (
        <span
          className={`status-badge ${getStatusClass(row.requester_status)}`}
        >
          {row.requester_status || "NA"}
        </span>
      );
    },
  },
];
